import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import ErrorText from "../../components/Typography/ErrorText";
import InputText from "../../components/Input/InputText";
import CheckCircleIcon from "@heroicons/react/24/solid/CheckCircleIcon";
import { ErrorAlert, SuccessAlert } from "../../components/Alerts/SuccessAlert";
import { useDispatch } from "react-redux";
import { resetLink } from "../../features/common/SchoolSlice";
import { useParams } from "react-router-dom";
function SchoolTeacherForgetPass() {
  const INITIAL_USER_OBJ = {
    emailId: "",
  };

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [linkSent, setLinkSent] = useState(false);
  const [userObj, setUserObj] = useState(INITIAL_USER_OBJ);

  let dispatch = useDispatch();
  const { role } = useParams(); // 👈 get role from URL
  // console.log("RAW ROLE FROM useParams:", role);
  // console.log("PATHNAME:", window.location.pathname);
  const roleMap = {
    teacher: "teacher",
  };
  const submitForm = async (e) => {
    try {
      e.preventDefault();
      setErrorMessage("");

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if (!emailRegex.test(userObj.emailId)) {
        return setErrorMessage("Please enter a valid Email Id");
      }

      setLoading(true);

      const normalizedRole = roleMap[role];
      if (!normalizedRole) {
        ErrorAlert("Invalid role in URL");
        return;
      }

      const baseURLLink = window.location.origin;

      const { payload } = await dispatch(
        resetLink({
          email: userObj.emailId,
          role,
          baseURLLink,
        })
      );

      // console.log("reset link", payload);

      if (payload?.token) {
        localStorage.setItem("forgetToken", payload.token);
      }

      if (payload?.status === 200) {
        SuccessAlert(payload.message);
        setLinkSent(true);
        setUserObj(INITIAL_USER_OBJ);
      } else {
        ErrorAlert(payload?.message);
        setLinkSent(false);
      }
    } catch (error) {
      ErrorAlert(error.message);
      setLinkSent(false);
      console.error("error form forgot password", error);
    } finally {
      setLoading(false);
    }
  };

  const updateFormValue = ({ updateType, value }) => {
    setErrorMessage("");
    setUserObj({ ...userObj, [updateType]: value });
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="w-full max-w-5xl bg-white rounded-2xl shadow-lg overflow-hidden grid grid-cols-1 md:grid-cols-2">
        {/* LEFT SIDE – FORM */}
        <div className="p-10 md:p-12">
          <h2 className="text-3xl font-semibold mb-2">Forgot Password</h2>
          <p className="text-gray-500 mb-8">
            We will send a password reset link to your email
          </p>

          {linkSent ? (
            <>
              <div className="text-center mt-10">
                <CheckCircleIcon className="w-20 mx-auto text-green-500" />
                <p className="mt-4 text-lg font-semibold">Link Sent</p>
                <p className="text-gray-500 mt-2">
                  Check your email to reset your password
                </p>
                <Link
                  to="/teacher/login"
                  className="text-sm text-indigo-600 hover:underline"
                >
                  Back to Login
                </Link>
              </div>
            </>
          ) : (
            <form onSubmit={submitForm} className="space-y-3">
              <div>
                <label className="block text-sm font-medium ">
                  Email Address
                </label>
                <InputText
                  type="emailId"
                  defaultValue={userObj.emailId}
                  updateType="emailId"
                  updateFormValue={updateFormValue}
                />
              </div>

              {errorMessage && (
                <p className="text-sm text-red-500">{errorMessage}</p>
              )}

              <button
                type="submit"
                className={`w-[90%] bg-gradient-to-r from-violet-500 to-indigo-600 text-white py-2 rounded-lg transition ${
                  loading ? "opacity-70 cursor-not-allowed" : "hover:opacity-90"
                }`}
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </button>

              <div className=" w-[90%] text-center">
                <Link
                  to="/teacher/login"
                  className="text-sm text-indigo-600 hover:underline"
                >
                  Back to Login
                </Link>
              </div>
            </form>
          )}
        </div>

        {/* RIGHT SIDE – ILLUSTRATION */}
        <div className="hidden md:flex items-center justify-center bg-gradient-to-b from-indigo-400 to-violet-500">
          <div className="w-72 h-72 overflow-hidden flex items-center justify-center">
            <img
              src="/final_logo_ver2.png"
              alt="Forgot Password"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SchoolTeacherForgetPass;
